import { ConfirmReceiveDocumentModalHook } from './ConfirmReceiveDocumentModal.hook'
import { Button, Content, StyledModal } from './styles'
import { ConfirmReceiveDocumentModalProps } from './types'

function ConfirmReceiveDocumentModal({
  isModalOpen,
  onClose,
  onConfirm,
  isLoading = false,
  centered = false,
}: ConfirmReceiveDocumentModalProps) {
  const { modalContent } = ConfirmReceiveDocumentModalHook()

  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      width={350}
      centered={centered}
      onCancel={onClose}
      title={modalContent.title}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={isLoading}>
          {modalContent.cancelText}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
          loading={isLoading}
          disabled={isLoading}
        >
          {modalContent.confirmText}
        </Button>,
      ]}
    >
      <Content>{modalContent.content}</Content>
    </StyledModal>
  )
}

export default ConfirmReceiveDocumentModal
